module.exports = __webpack_public_path__ + "img/icon-payment-app-blue.63a66d81.png";